<template>
  <div class="rounded-lg overflow-hidden" data-testid="data-processing-table">
    <v-simple-table class="data-processing-table" :loading="loading">

      <!-- ===== MASTERS TABLE HEADER ===== -->
      <thead v-if="type === 'masters'" class="tableHeaderBg">
        <tr class="group-header">
          <th rowspan="2" class="border-right">
            <HeaderCell
              text="Batch Ref"
              value="indexno"
              :sortable="false"
              :filterable="true"
              :sort-key="sortKey"
              :sort-desc="sortDesc"
              @sort="handleSort"
            />
          </th>
          <th rowspan="2" class="border-right">
            <HeaderCell
              text="Date"
              value="date"
              :sortable="false"
              :filterable="false"
              :sort-key="sortKey"
              :sort-desc="sortDesc"
              @sort="handleSort"
              style="min-width: 150px;"
            />
          </th>
          <th rowspan="2" class="border-right">
            <HeaderCell
              text="Type"
              value="__codename"
              :sortable="false"
              :filterable="true"
              :sort-key="sortKey"
              :sort-desc="sortDesc"
              :filter-options="getFilterOptions('__codename')"
              :current-filters="filters['__codename']"
              @sort="handleSort"
              @filter="handleFilter"
              style="min-width: 200px;"
            />
          </th>
          <th rowspan="2" class="border-right">
            <HeaderCell
              text="Status"
              value="status"
              :sortable="false"
              :filterable="true"
              :sort-key="sortKey"
              :sort-desc="sortDesc"
              :filter-options="getFilterOptions('status')"
              :current-filters="filters['status']"
              @sort="handleSort"
              @filter="handleFilter"
            />
          </th>
          <th rowspan="2" class="border-right">Benchmark for Validation</th>
          <th colspan="2" class="border-right border-bottom">Overall Validation</th>
        </tr>
        <tr class="sub-header">
          <th class="border-right">As per Source ERP - Overall</th>
          <th class="border-right">As per Flux App - Overall</th>
        </tr>
      </thead>

      <!-- ===== DRILLDOWN TABLE HEADER ===== -->
      <thead v-else-if="type === 'drilldown'" class="tableHeaderBg">
        <tr class="group-header">
          <th rowspan="2" class="border-right">
            <HeaderCell text="Batch Ref" value="indexno" :sortable="false" :filterable="true" :sort-key="sortKey" :sort-desc="sortDesc" @sort="handleSort" />
          </th>
          <th rowspan="2" class="border-right">
            <HeaderCell text="Date" value="date" :sortable="false" :filterable="false" :sort-key="sortKey" :sort-desc="sortDesc" @sort="handleSort" style="min-width: 150px;" />
          </th>
          <th rowspan="2" class="border-right">
            <HeaderCell text="Type" value="__codename" :sortable="false" :filterable="true" :sort-key="sortKey" :sort-desc="sortDesc" :filter-options="getFilterOptions('__codename')" :current-filters="filters['__codename']" @sort="handleSort" @filter="handleFilter" style="min-width: 200px;" />
          </th>
          <th rowspan="2" class="border-right">
            <HeaderCell text="Status" value="status" :sortable="false" :filterable="true" :sort-key="sortKey" :sort-desc="sortDesc" :filter-options="getFilterOptions('status')" :current-filters="filters['status']" @sort="handleSort" @filter="handleFilter" />
          </th>
          <th rowspan="2" class="border-right">Benchmark for Validation</th>
          <th colspan="3" class="border-right border-bottom">Actual Cycle</th>
          <th v-if="showComparative1" colspan="3" class="border-right border-bottom">Comparative 1</th>
        </tr>
        <tr class="sub-header">
          <!-- Actual Cycle -->
          <th class="border-right">As per Parent GLs (Delta)</th>
          <th class="border-right">As per Drill-Down (Delta)</th>
          <th class="border-right">No of RUs With Mismatches (Delta)</th>
          <!-- Comparative 1 -->
          <template v-if="showComparative1">
            <th class="border-right">As per Parent GLs (Delta)</th>
            <th class="border-right">As per Drill-Down (Delta)</th>
            <th class="border-right">No of RUs With Mismatches (Delta)</th>
          </template>
        </tr>
      </thead>

      <!-- ===== GL DASHBOARD TABLE HEADER ===== -->
      <thead v-else class="tableHeaderBg">
        <tr class="group-header">
          <th rowspan="2" class="border-right">
             <HeaderCell 
                text="Batch Ref" 
                value="indexno"
                :sortable="false"
                :filterable="true"
                :sort-key="sortKey"
                :sort-desc="sortDesc"
                @sort="handleSort"
            />
          </th>
          <th rowspan="2" class="border-right">
             <HeaderCell 
                text="Date" 
                value="date"
                :sortable="false"
                :filterable="false"
                :sort-key="sortKey"
                :sort-desc="sortDesc"
                :filter-options="getFilterOptions('date')"
                :current-filters="filters['date']"
                @sort="handleSort"
                @filter="handleFilter"
                style="min-width: 150px;"
            />
          </th>
          <th rowspan="2" class="border-right">
            <HeaderCell 
                text="Type" 
                value="__codename"
                :sortable="false"
                :filterable="true"
                :sort-key="sortKey"
                :sort-desc="sortDesc"
                :filter-options="getFilterOptions('__codename')"
                :current-filters="filters['__codename']"
                @sort="handleSort"
                @filter="handleFilter"
                style="min-width: 200px;"
            />
          </th>
          <th rowspan="2" class="border-right">
             <HeaderCell 
                text="Status" 
                value="status"
                :sortable="false"
                :filterable="true"
                :sort-key="sortKey"
                :sort-desc="sortDesc"
                :filter-options="getFilterOptions('status')"
                :current-filters="filters['status']"
                @sort="handleSort"
                @filter="handleFilter"
            />
          </th>
          <th rowspan="2" class="border-right">Benchmark for Validation</th>
          <th colspan="4" class="border-right border-bottom">Actual Cycle</th>
          <th v-if="showComparative1" colspan="4" class="border-right border-bottom">Comparative 1</th>
          <th v-if="showComparative2" colspan="4" class="border-right border-bottom">Comparative 2</th>
        </tr>
        <tr class="sub-header">
          <!-- Actual Cycle -->
          <th class="border-right">As per Source ERP - Overall</th>
          <th class="border-right">As per Flux App - Overall</th>
          <th class="border-right">As Per ETL (Delta)</th>
          <th class="border-right">As Per Application (Delta)</th>

          <!-- Comparative 1 -->
          <template v-if="showComparative1">
            <th class="border-right">As per Source ERP - Overall</th>
            <th class="border-right">As per Flux App - Overall</th>
            <th class="border-right">As Per ETL (Delta)</th>
            <th class="border-right">As Per Application (Delta)</th>
          </template>

          <!-- Comparative 2 -->
          <template v-if="showComparative2">
            <th class="border-right">As per Source ERP - Overall</th>
            <th class="border-right">As per Flux App - Overall</th>
            <th class="border-right">As Per ETL (Delta)</th>
            <th class="border-right">As Per Application (Delta)</th>
          </template>
        </tr>
      </thead>

      <!-- ===== MASTERS BODY ===== -->
      <tbody v-if="type === 'masters'">
        <template v-if="loading">
          <tr v-for="i in 5" :key="i">
            <td v-for="j in 7" :key="j" class="border-right">
              <v-skeleton-loader type="text" class="my-2" />
            </td>
          </tr>
        </template>
        <template v-else>
          <tr v-if="!filteredAndSortedItems || filteredAndSortedItems.length === 0">
            <td colspan="7" class="grey--text pa-4 text-center">No Data</td>
          </tr>
          <tr v-else v-for="(item, index) in visibleItems" :key="index" @click.stop="$emit('row-click', item)" class="cursor-pointer hover-row">
            <td class="border-right">{{ item.raw.batch_ref || '-' }}</td>
            <td class="border-right">{{ item.date }}</td>
            <td class="border-right">{{ item.__codename || item.code }}</td>
            <td class="border-right">
              <div v-if="item.error_flag">
                <status-indicator variant="rejected" custom-label="Error" size="sm" />
              </div>
              <div v-else-if="item.status === 'Completed'" class="d-flex align-center">
                <status-indicator variant="approved" custom-label="Completed" size="sm" />
              </div>
              <div v-else-if="item.status === 'Failed'" class="d-flex align-center">
                <status-indicator variant="failed" custom-label="Failed" size="sm" />
              </div>
              <div v-else>
                <status-indicator variant="pending-approval" :custom-label="item.status" size="sm" />
              </div>
            </td>
            <td class="border-right">{{ item.benchmark || '-' }}</td>
            <td class="border-right text-right">{{ item.receivedcount }}</td>
            <td class="border-right text-right">{{ item.processedcount }}</td>
          </tr>
        </template>
      </tbody>

      <!-- ===== DRILLDOWN BODY ===== -->
      <tbody v-else-if="type === 'drilldown'">
        <template v-if="loading">
          <tr v-for="i in 5" :key="i">
            <td v-for="j in drilldownColspan" :key="j" class="border-right">
              <v-skeleton-loader type="text" class="my-2" />
            </td>
          </tr>
        </template>
        <template v-else>
          <tr v-if="!filteredAndSortedItems || filteredAndSortedItems.length === 0">
            <td :colspan="drilldownColspan" class="grey--text pa-4 text-center">No Data</td>
          </tr>
          <tr v-else v-for="(item, index) in visibleItems" :key="index" @click.stop="$emit('row-click', item)" class="cursor-pointer hover-row">
            <td class="border-right">{{ item.raw.batch_ref || '-' }}</td>
            <td class="border-right">{{ item.date }}</td>
            <td class="border-right">{{ item.__codename || item.code }}</td>
            <td class="border-right">
              <div v-if="item.error_flag">
                <status-indicator variant="rejected" custom-label="Error" size="sm" />
              </div>
              <div v-else-if="item.status === 'Completed'" class="d-flex align-center">
                <status-indicator variant="approved" custom-label="Completed" size="sm" />
              </div>
              <div v-else-if="item.status === 'Failed'" class="d-flex align-center">
                <status-indicator variant="failed" custom-label="Failed" size="sm" />
              </div>
              <div v-else>
                <status-indicator variant="pending-approval" :custom-label="item.status" size="sm" />
              </div>
            </td>
            <td class="border-right">{{ item.raw.benchmark || '-' }}</td>
            <!-- Actual Cycle -->
            <td class="border-right text-right">{{ item.bfcreceivedcount }}</td>
            <td class="border-right text-right">{{ item.receivedcount }}</td>
            <td class="border-right text-right">{{ item.raw.discrepancy_cycles ? item.raw.discrepancy_cycles.length : '-' }}</td>
            <!-- Comparative 1 -->
            <template v-if="showComparative1">
              <td class="border-right text-right">{{ item.bfcreceivedcount_proforma }}</td>
              <td class="border-right text-right">{{ item.receivedcount_proforma }}</td>
              <td class="border-right text-right">-</td>
            </template>
          </tr>
        </template>
      </tbody>

      <!-- ===== GL DASHBOARD BODY ===== -->
      <tbody v-else>
        <template v-if="loading">
          <tr v-for="i in 5" :key="i">
            <td v-for="j in gldataColspan" :key="j" class="border-right">
              <v-skeleton-loader type="text" class="my-2" />
            </td>
          </tr>
        </template>
        <template v-else>
          <tr v-if="!filteredAndSortedItems || filteredAndSortedItems.length === 0">
            <td :colspan="gldataColspan" class="grey--text pa-4 text-center">No Data</td>
          </tr>
          <tr v-else v-for="(item, index) in visibleItems" :key="index" @click.stop="$emit('row-click', item)" class="cursor-pointer hover-row">
          <td class="border-right">{{ item.raw.batch_ref || '-' }}</td>
          <td class="border-right">{{ item.date }}</td>
          <td class="border-right">
             {{ item.__codename || item.code }}
          </td>
          <td class="border-right">
              <div v-if="item.error_flag">
                <status-indicator variant="rejected" custom-label="Error" size="sm" />
              </div>
              <div v-else-if="item.status === 'Completed'" class="d-flex align-center">
                <status-indicator variant="approved" custom-label="Completed" size="sm" />
              </div>
              <div v-else-if="item.status === 'Failed'" class="d-flex align-center">
                <status-indicator variant="failed" custom-label="Failed" size="sm" />
              </div>
              <div v-else>
                <status-indicator variant="pending-approval" :custom-label="item.status" size="sm" />
              </div>
          </td>
          <td class="border-right">
             <!-- Benchmark for Validation -->
              {{ item.benchmark || '-' }}
          </td>
          
          <td class="border-right text-right">
             <!-- As Per Source ERP Overall -->
             {{ item?.bfcreceivedcount }} {{ item.unit }}
             <br />
             <span v-if="item.bfcreceivedcount_ru != undefined" class="">{{ item.bfcreceivedcount_ru }} RUs</span>
          </td>
          <td class="border-right text-right">
             <!-- As Per Flux App Overall (Startlight Overall) -->
            <div v-if="item.all_pbt_sum_actual && item.all_ru_count">
              {{ item.all_pbt_sum_actual }} {{item.unit}}
              <br />
              <span v-if="item.all_ru_count != undefined" class="">{{ $nova.formatNumber(item.all_ru_count) }} RUs</span>
            </div>
            <div v-else>
              -
            </div>
          </td>
          <td class="border-right text-right">
              <!-- As Per ETL(Delta) (Databricks) -->
              {{ item.receivedcount }} {{ item.unit }}
              <br />
              <span v-if="item.receivedcount_ru != undefined" class="">{{ item.receivedcount_ru }} RUs</span>
          </td>
          <td class="border-right text-right">
             <!-- As Per Application(Delta) (Starlight) -->
              {{ item.processedcount }} {{ item.unit }}
              <br />
              <span v-if="item.processedcount_ru != undefined" class="">{{ item.processedcount_ru }} RUs</span>
          </td>

          <template v-if="showComparative1">
          <td class="border-right text-right">
            <!-- Comp 1: Source ERP -->
             {{ item?.bfcreceivedcount_proforma }} {{ item.unit }}
            <br />
            <span v-if="item.bfcreceivedcount_ru_proforma != undefined" class="">{{ item.bfcreceivedcount_ru_proforma }} RUs</span>
          </td>
          <td class="border-right text-right">
            <!-- Comp 1: Flux App Overall -->
            <div v-if="item.all_pbt_sum_proforma && item.all_ru_count_proforma">
              {{ item.all_pbt_sum_proforma }} {{item.unit}}
              <br />
              <span v-if="item.all_ru_count_proforma != undefined" class="">{{ $nova.formatNumber(item.all_ru_count_proforma) }} RUs</span>
            </div>
            <div v-else>
              -
            </div>
          </td>
          <td class="border-right text-right">
             <!-- Comp 1: ETL Delta -->
             {{ item.receivedcount_proforma }} {{ item.unit }}
            <br />
            <span v-if="item.receivedcount_ru_proforma != undefined" class="">{{ item.receivedcount_ru_proforma }} RUs</span>
          </td>
          <td class="border-right text-right">
            <!-- Comp 1: App Delta -->
            {{ item.processedcount_proforma }} {{ item.unit }}
            <br />
            <span v-if="item.processedcount_ru_proforma != undefined" class="">{{ item.processedcount_ru_proforma }} RUs</span>
          </td>
          </template>

          <template v-if="showComparative2">
          <td class="border-right text-right">
            <!-- Forecast: Source ERP -->
             {{ item?.bfcreceivedcount_forecast }} {{ item.unit }}
            <br />
            <span v-if="item.bfcreceivedcount_ru_forecast != undefined" class="">{{ item.bfcreceivedcount_ru_forecast }} RUs</span>
          </td>
          <td class="border-right text-right">
            <!-- Forecast: Flux App Overall -->
            <div v-if="item.all_pbt_sum_forecast && item.all_ru_count_forecast">
              {{ item.all_pbt_sum_forecast }} {{item.unit}}
              <br />
              <span v-if="item.all_ru_count_forecast != undefined" class="">{{ $nova.formatNumber(item.all_ru_count_forecast) }} RUs</span>
            </div>
            <div v-else>
              -
            </div>
          </td>
          <td class="border-right text-right">
             <!-- Forecast: ETL Delta -->
             {{ item.receivedcount_forecast }} {{ item.unit }}
            <br />
            <span v-if="item.receivedcount_ru_forecast != undefined" class="">{{ item.receivedcount_ru_forecast }} RUs</span>
          </td>
          <td class="border-right text-right">
            <!-- Forecast: App Delta -->
            {{ item.processedcount_forecast }} {{ item.unit }}
            <br />
            <span v-if="item.processedcount_ru_forecast != undefined" class="">{{ item.processedcount_ru_forecast }} RUs</span>
          </td>
          </template>
        </tr>
        </template>
      </tbody>

    </v-simple-table>
    <pagination
      v-if="filteredAndSortedItems.length > 0"
      :list="filteredAndSortedItems"
      :itemsperpage="25"
      @paginated-data="updatePaginatedData"
    />
  </div>
</template>

<script>
import Pagination from '@/views/common/Pagination.vue';
import HeaderCell from '../../WorkflowConfig/components/HeaderCell.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';

export default {
  name: 'DataProcessingTable',
  components: {
    Pagination,
    HeaderCell,
    StatusIndicator
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'gldata'
    },
    showComparative1: {
      type: Boolean,
      default: false
    },
    showComparative2: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visibleItems: [],
      sortKey: '',
      sortDesc: false,
      filters: {
        date: [],
        __codename: [],
        status: []
      }
    }
  },
  computed: {
    drilldownColspan() {
      // Base: 5 (Ref, Date, Type, Status, Benchmark) + 3 (Actual)
      return 8 + (this.showComparative1 ? 3 : 0);
    },
    gldataColspan() {
      // Base: 5 (Ref, Date, Type, Status, Benchmark) + 4 (Actual)
      return 9 + (this.showComparative1 ? 4 : 0) + (this.showComparative2 ? 4 : 0);
    },
    filteredAndSortedItems() {
      let items = [...this.items];

      // Filter
      Object.keys(this.filters).forEach(key => {
        const selectedValues = this.filters[key];
        if (selectedValues && selectedValues.length > 0) {
          items = items.filter(item => selectedValues.includes(item[key]));
        }
      });

      // Sort
      if (this.sortKey) {
        items.sort((a, b) => {
          let aVal = a[this.sortKey];
          let bVal = b[this.sortKey];
          
          // Handle dates specifically if needed, logic depends on date format
          // Assuming simple string or number comparison for now
          
          if (aVal === bVal) return 0;
          
          let result = 0;
          if (aVal > bVal) result = 1;
          else result = -1;

          return this.sortDesc ? -result : result;
        });
      }

      return items;
    }
  },
  methods: {
    updatePaginatedData(payload) {
      this.visibleItems = payload.data;
    },
    handleSort(key) {
      if (this.sortKey === key) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortKey = key;
        this.sortDesc = false;
      }
    },
    handleFilter({ key, values }) {
      this.$set(this.filters, key, values);
    },
    getFilterOptions(key) {
      const uniqueValues = new Set(this.items.map(item => item[key]).filter(Boolean));
      return Array.from(uniqueValues).sort();
    }
  },
  watch: {
    // When items change, we need to re-run filtering/sorting indirectly by using computed prop in pagination list
  }
}
</script>

<style scoped>
.border-right {
  border-right: 1px solid rgba(0,0,0,0.12) !important;
}
.border-bottom {
  border-bottom: 1px solid rgba(0,0,0,0.12) !important;
}
.border-left {
  border-left: 1px solid rgba(0,0,0,0.12) !important;
}
.border-top {
  border-top: 1px solid rgba(0,0,0,0.12) !important;
}

.cursor-pointer {
  cursor: pointer;
}

.hover-row:hover > td {
  background-color: #f5f5f5 !important;
}
.data-processing-table th{
  white-space: nowrap;
}
</style>